import {
  AppBadge,
  AppButton,
  AppCard,
  AppDialog,
  AppIconButton,
  AppTab,
  AppTabContent,
  AppTabList,
  AppTabTrigger,
} from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { ExternalLink } from 'lucide-react'
import { useState } from 'react'

interface ServiceCardProps {
  service: {
    serviceName: string
    serviceDescription: string
    serviceHint: string
    serviceUri: string
    serviceSegmentName: string
    serviceSegmentColor: string | null
    serviceCategoryName: string
    serviceCategoryColor: string | null
  }
  onSearchClick: (query: string) => void
}

/**
 * サービスカードコンポーネント
 *
 * 個別のSHIFTサービス情報をカード形式で表示します。
 */
export function ServiceCard({ service, onSearchClick }: ServiceCardProps) {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <>
      {/* TODO: ここのカードのデザインもっとよくできる。ヘッダーに色付いてもいいかも。サービス名→バッジ、の順のほうがいいかも */}
      <AppCard
        className='flex flex-col justify-between h-full overflow-hidden'
        asContent={false}
        footer={
          <div className='flex justify-end gap-2 w-full'>
            <AppButton variant='outline' onClick={() => setIsDialogOpen(true)}>
              詳細
            </AppButton>
            <AppIconButton description='サービスサイトを開きます'>
              <a href={service.serviceUri} target='_blank' rel='noopener noreferrer'>
                <ExternalLink />
              </a>
            </AppIconButton>
          </div>
        }
      >
        {/* TODO: Vuetifyからの移行でバッジの色分けが機能していません。従来のDBに色情報を持つ仕組みは良くないです。フロントエンド側で色分けの機構を実装してください。 */}
        <div className='flex-1 px-4'>
          <div className='flex flex-col gap-1'>
            <div>
              <AppBadge outline clickable onClick={() => onSearchClick(service.serviceSegmentName)}>
                {service.serviceSegmentName}
              </AppBadge>
            </div>
            <div>
              <AppBadge outline clickable onClick={() => onSearchClick(service.serviceCategoryName)}>
                {service.serviceCategoryName}
              </AppBadge>
            </div>
          </div>
          <div className='h-20 flex items-center'>
            <p className='text-lg font-bold line-clamp-3'>{service.serviceName}</p>
          </div>
        </div>
      </AppCard>

      <AppDialog
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        title={service.serviceName}
        className='max-w-2xl'
        footerOptions={[{ label: 'OK', onClick: () => setIsDialogOpen(false) }]}
      >
        <AppTab defaultValue='description' className='w-full'>
          <AppTabList className='grid w-full grid-cols-2'>
            <AppTabTrigger value='description'>説明</AppTabTrigger>
            <AppTabTrigger value='hint'>課題例</AppTabTrigger>
          </AppTabList>
          <AppTabContent value='description' className='mt-4'>
            <div className='whitespace-pre-line text-sm'>{service.serviceDescription}</div>
          </AppTabContent>
          <AppTabContent value='hint' className='mt-4'>
            <div className='whitespace-pre-line text-sm'>{service.serviceHint}</div>
          </AppTabContent>
        </AppTab>
      </AppDialog>
    </>
  )
}
